import React, { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ErrorImg from '../../assets/error_img.png';
//components
import Header from '../../components/Header';
import { UseContext } from '../../context/useContext';

export default function Error() {
	const [searchParams] = useSearchParams();
	const [origem, setOrigem] = useState(null);
	const [transactionErrors, setTransactionErrors] = useState([]);

	const { errorMessage } = useContext(UseContext);

	useEffect(() => {
		const searchParamOrigem = searchParams.get('origem');
		setOrigem(Number(searchParamOrigem));

		const searchParamTransactionErrors = searchParams.get('transactionErrors');
		setTransactionErrors(
			searchParamTransactionErrors ? searchParamTransactionErrors.split(',') : [],
		);
	}, [searchParams]);

	const formatErrorContent = (content) => {
		let stringifiedContent = '';
		if (content?.constructor === Object) {
			stringifiedContent = JSON.stringify(content, null, 4);
		} else {
			stringifiedContent = `${content || ''}`;
		}

		return stringifiedContent;
	};

	const isShowCardStatusMessage = () => {
		const errorText = formatErrorContent(errorMessage);

		if (errorText) {
			const txtSearch = ['insert', 'inesperado', 'update', 'select', 'delete'];
			for (let index = 0; index < txtSearch.length; index++) {
				const txt = txtSearch[index];

				if (String(errorText).toLowerCase().includes(txt)) {
					return false;
				}
			}
			return true;
		}
		return false;
	};

	return (
		<>
			<Header origem={origem} />
			<section className='w-screen flex flex-1 flex-col items-center justify-between py-12 px-4 rounded-t-2xl -mt-4 z-10 bg-white'>
				<div className='flex flex-1 flex-col items-center justify-center'>
					<div className='mb-2'>
						<img src={ErrorImg} alt='error' />
					</div>
					<p className='text-text_red text-xs mb-1 text-center font-medium'>
						Não foi possível realizar o lançamento
						<br />
					</p>
					{isShowCardStatusMessage() ? (
						<div className='mb-4'>
							<p className='text-text_red text-xs px-8 mb-4 text-center font-medium'>
								{formatErrorContent(errorMessage)}
							</p>
						</div>
					) : (
						<p className='text-text_red text-xs px-8 mb-4 text-center font-medium'>
							por favor volte ao paroquiaNet e tente novamente.
						</p>
					)}

					<p className='text-blue_navy mb-10 text-center text-xs font-medium'>
						Caso algum valor tenha sido debitado de seu cartão,
						<br />
						entre em contato com nosso{' '}
						<a
							className='text-text_blue underline'
							href='https://theos.com.br/contato/'>
							suporte.
						</a>
					</p>
				</div>
			</section>
		</>
	);
}
